/** TanStack Query key factory — centralizes cache keys for consistency */
export const queryKeys = {
  studies: {
    all: ['studies'] as const,
    paged: (params: Record<string, unknown>) =>
      ['studies', 'paged', params] as const,
    detail: (uid: string) => ['studies', 'detail', uid] as const,
  },
  counters: {
    all: ['counters'] as const,
  },
  users: {
    all: ['users'] as const,
    detail: (key: string) => ['users', 'detail', key] as const,
  },
  sites: {
    all: ['sites'] as const,
    detail: (key: string) => ['sites', 'detail', key] as const,
  },
  reports: (studyUid: string) => ['reports', studyUid] as const,
  comparisons: (studyUid: string) => ['comparisons', studyUid] as const,
  linkedStudies: (objKey: string) => ['linkedStudies', objKey] as const,
  objects: (studyUid: string) => ['objects', studyUid] as const,
  messages: {
    all: ['messages'] as const,
    detail: (key: string) => ['messages', 'detail', key] as const,
  },
  jobs: {
    all: ['jobs'] as const,
  },
  patients: {
    all: ['patients'] as const,
    detail: (key: string) => ['patients', 'detail', key] as const,
  },
  systemSummary: ['systemSummary'] as const,
  session: {
    validate: ['session', 'validate'] as const,
  },
  protocols: {
    all: (scope?: string) => ['protocols', scope ?? 'all'] as const,
  },
  savedSearches: ['savedSearches'] as const,
} as const;
